import { zodResolver } from '@hookform/resolvers/zod';
import { MessageMedium } from 'modules/domains/campaign';
import React, { useEffect, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';
import isEmpty from 'lodash/isEmpty';
import { EmbeddedMessageMedium } from 'constants/messageMediums';
import { useTemplateQueryContext } from './TemplateQueryContext';

const BaseTemplateSchema = z.object({
  name: z.string(),
  cacheDataFeed: z.boolean().optional(),
  mergeDataFeedContext: z.boolean().optional(),
  referenceDataFeedsByAlias: z.boolean().optional(),
});
const BaseMediumSchema = z.object({
  dataFeedIds: z.array(z.number()).optional(),
});
const BaseEmailSchema = z.object({});
const BaseInAppSchema = z.object({});
const BaseSMSSchema = z.object({});
const BasePushSchema = z.object({});
const BaseWebAppSchema = z.object({});
const BaseEmbeddedSchema = z.object({});

const SCHEMA_MEDIUM_MAPPER: { [key in MessageMedium | EmbeddedMessageMedium]: any } = {
  [MessageMedium.Email]: BaseMediumSchema.merge(BaseEmailSchema),
  [MessageMedium.InApp]: BaseMediumSchema.merge(BaseInAppSchema),
  [MessageMedium.SMS]: BaseMediumSchema.merge(BaseSMSSchema),
  [MessageMedium.WebPush]: BaseMediumSchema.merge(BaseWebAppSchema),
  [EmbeddedMessageMedium.Embedded]: BaseMediumSchema.merge(BaseEmbeddedSchema),
  [MessageMedium.Push]: BaseMediumSchema.merge(BasePushSchema),
};

export const EditorFormProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  const { medium, template, isLoading } = useTemplateQueryContext();

  const mediumSchema = SCHEMA_MEDIUM_MAPPER[medium as MessageMedium];

  const schema = BaseTemplateSchema.extend({
    mediumData: mediumSchema,
  });

  type TemplateEditorFormSchema = Required<z.infer<typeof schema>>;

  const initialValues = useMemo(() => {
    return JSON.parse(template);
  }, [template]);

  const methods = useForm<TemplateEditorFormSchema>({
    defaultValues: initialValues,
    mode: 'onChange',
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    if (!!isLoading || isEmpty(initialValues)) return;
    methods.reset(initialValues);
  }, [template, isLoading]);

  return <FormProvider {...methods}>{children}</FormProvider>;
};
